module.exports = __webpack_public_path__ + "images/application/templates/layout-basic@2x-60ceff5b.png";